// src/pages/admin/sessions/AttendanceView.jsx
import React from "react";
import AttendanceView from "../../../components/attendance/AttendanceView";

const AdminAttendanceView = () => {
    return <AttendanceView role="ADMIN" />;
};

export default AdminAttendanceView;